<template>
  <div class="wrapper">
    <AdminBreadCrumb title="アカウント管理" />
    <AccountList
      :search-result="searchResult"
      :user-belong-type="userBelongType"
      :user-belong-id="userBelongId"
      :user-type="userType"
      :system-owner-list="systemOwnerList"
      :agency-list="agencyList"
      :advertiser-list="advertiserList"
      :admin-agency-list="adminAgencyList"
      :admin-advertiser-list="adminAdvertiserList"
      :agency-list-for-search="agencyListForSearch"
      :advertiser-list-for-search="advertiserListForSearch"
      :agency-auth-chain="agencyAuthChain"
      :advertiser-auth-chain="advertiserAuthChain"
      :dispatch-get-agency-account-auth="dispatchGetAgencyAccountAuth"
      :dispatch-get-advertiser-account-auth="dispatchGetAdvertiserAccountAuth"
      :loading="loading"
      @search="search"
    />
  </div>
</template>

<script>
import { accountInitializer } from '@/mixins/accountInitializer'
import { setDrawerTypeAdmin } from '@/mixins/setDrawerTypeAdmin'
import { setToolBarTypeAdmin } from '@/mixins/setToolBarTypeAdmin'

import AccountList from '@/components/Admin/Account/AccountList'
import AdminBreadCrumb from '@/components/Shared/BreadCrumb/AdminBreadCrumb'

export default {
  name: 'Account',
  components: { AccountList, AdminBreadCrumb },
  mixins: [accountInitializer, setDrawerTypeAdmin, setToolBarTypeAdmin],
  computed: {
    loading() {
      return this.$store.getters['accountList/loading']
    },
    searchResult() {
      return this.$store.getters['accountList/searchResult']
    },
    systemOwnerList() {
      return this.$store.getters['accountList/systemOwnerList']
    },
    agencyList() {
      return this.$store.getters['accountList/agencyList']
    },
    advertiserList() {
      return this.$store.getters['accountList/advertiserList']
    },
    userBelongType() {
      return this.$store.getters['account/belongType']
    },
    userBelongId() {
      return this.$store.getters['account/belongId']
    },
    userType() {
      return this.$store.getters['account/userType']
    },
    isUserSystemOwner() {
      return this.$store.getters['account/isSystemOwner']
    },
    isUserNotLessThanAgency() {
      return this.$store.getters['account/isNotLessThanAgency']
    },
    adminAgencyList() {
      // 権限付与のときの選択肢
      return this.$store.getters['agency/agencyList']
    },
    agencyListForSearch() {
      // 検索Barのセレクトボックスの選択肢
      return this.$store.getters['accountList/agencyListForSearch']
    },
    agencyAuthChain() {
      return this.$store.getters['agencyAccountAuth/getAuthChain']
    },
    adminAdvertiserList() {
      // 権限付与のときの選択肢
      return this.$store.getters['admin/advertiser/advertiserList']
    },
    advertiserListForSearch() {
      // 検索Barのセレクトボックスの選択肢
      return this.$store.getters['accountList/advertiserListForSearch']
    },
    advertiserAuthChain() {
      return this.$store.getters['advertiserAccountAuth/getAuthChain']
    },
  },
  watch: {
    userBelongId() {
      this.init()
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      // ページリロードのときはaccountInitializerが終わるまで待つ
      if (!this.userBelongId) return
      // アカウント一覧取得のための検索
      this.initSearchOptions()
      // アカウント一覧取得
      let searchParams = {}
      if (this.userBelongType === 'agency') {
        searchParams.agencyId = this.userBelongId
      }
      if (this.userBelongType === 'advertiser') {
        searchParams.advertiserId = this.userBelongId
      }
      this.search(searchParams)
      this.searchForInvite()
    },
    // searchBar内のv-selectの選択肢を取得
    initSearchOptions() {
      if (this.isUserSystemOwner) return
      if (this.userBelongType === 'agency') {
        // view権限を持っている代理店一覧取得
        this.$store.dispatch('accountList/GET_AGENCY_LIST_FOR_SEARCH', {
          minPermissionLevel: 'view',
        })
      }
      // view権限を持っている広告主一覧取得
      this.$store.dispatch('accountList/GET_ADVERTISER_LIST_FOR_SEARCH', {
        minPermissionLevel: 'view',
      })
    },
    search({ keyword, belongType, pageSize, pageNo } = {}) {
      const searchParams = {
        keyword,
        belongType,
        pageSize,
        pageNo,
      }
      this.$store.dispatch('accountList/GET_ACCOUNT_LIST', searchParams)
    },
    searchForInvite() {
      if (this.isUserSystemOwner)
        this.$store.dispatch('accountList/GET_SYSTEM_OWNER_LIST')
    },
    // 代理店権限編集モーダルに渡す関数
    dispatchGetAgencyAccountAuth({ agencyId, accountId, userType }) {
      this.$store.dispatch('agencyAccountAuth/GET', {
        agencyId,
        accountId,
        userType,
      })
    },
    // 広告主権限編集モーダルに渡す関数
    dispatchGetAdvertiserAccountAuth({ advertiserId, accountId, userType }) {
      this.$store.dispatch('advertiserAccountAuth/GET', {
        advertiserId,
        accountId,
        userType,
      })
    },
  },
}
</script>

<style scoped>
.wrapper {
  width: 100%;
}
</style>
